import Typography from '@material-ui/core/Typography';
import React from 'react';
import { FormattedNumber } from 'react-intl';

import type { ISubscriptions } from 'v2/interfaces/subscriptions';

import { tableHeaders } from './tableHeaders';
import MyTable from '../../MyTable';
import MyTableBody from '../../MyTable/MyTableBody';
import MyTableCol from '../../MyTable/MyTableCol';
import MyTableHeader from '../../MyTable/MyTableHeader';
import MyTableRow from '../../MyTable/MyTableRow';
import Truncate from '../../TruncateText';

interface IProps {
  data: ISubscriptions[];
}

const CardUsageTable = ({ data }: IProps) => {
  return (
    <MyTable responsive={false}>
      <MyTableHeader index={tableHeaders} />
      <MyTableBody>
        {data.map((use) => (
          <MyTableRow key={use.id}>
            <MyTableCol screenSizes={{ xs: 3, sm: 2 }}>{use.id}</MyTableCol>
            <MyTableCol screenSizes={{ xs: 6, sm: 8 }}>
              <div>
                <Truncate count='35' final='...'>
                  {use.product.title}
                </Truncate>
                <Typography variant='body2'>({use.product.id})</Typography>
              </div>
            </MyTableCol>
            <MyTableCol numeric screenSizes={{ xs: 3, sm: 2 }}>
              <FormattedNumber value={use.total_price} format='BRL' />
            </MyTableCol>
          </MyTableRow>
        ))}
      </MyTableBody>
    </MyTable>
  );
};

export default CardUsageTable;
